<template>
  <div class="allwidth position">
    <el-menu :default-active="activeIndex" :router="true" class="el-menu--horizontal" mode="horizontal" @select="handleSelect">
      <el-menu-item index="/courseware">我的课件</el-menu-item>
      <!-- <el-submenu index="2">
        <template slot="title">师资培训</template>
        <el-menu-item index="2-1">选项1</el-menu-item>
        <el-menu-item index="2-2">选项2</el-menu-item>
        <el-menu-item index="2-3">选项3</el-menu-item>
        <el-submenu index="2-4">
          <template slot="title">选项4</template>
          <el-menu-item index="2-4-1">选项1</el-menu-item>
          <el-menu-item index="2-4-2">选项2</el-menu-item>
          <el-menu-item index="2-4-3">选项3</el-menu-item>
        </el-submenu>
      </el-submenu> -->
      <el-menu-item index="/training">师资培训</el-menu-item>
      <el-menu-item index="/allList">所有课件</el-menu-item>

    </el-menu>
  </div>
</template>

<script>
  export default {
    name: 'middles',
    data() {
      return {

      }
    },
    props: {
      activeIndex: String,
    },
    methods: {
      handleSelect(){

      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .allwidth {
    width: 100%;
    border-bottom: 0px solid #E3E9FF;
    background-color: #fff;
  }

  .position {
    margin-left: 16%;
    width: auto;
    height: 60px;
    margin-bottom: -40px;
  }

  .el-menu {
    width: 100%;
    max-width: 1290px;
    margin: 0 auto;
    border: none !important;
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none !important;
    /* border-top: 4px solid #57BC4C; */
    line-height: 56px;
    position: relative;
    overflow: hidden !important;

  }
  .el-menu--horizontal>.el-menu-item.is-active::before{
    content:"";
    display: block;
    width: 62%;
    height: 4px;
    background: #57BC4C;
    position: absolute;
    top: 0px;
  }

  .el-menu--horizontal>.el-menu-item{font-size:16px;color:#666666;font-weight: 400;}
  .el-menu li{font-size: 20px !important;}
  .el-menu--horizontal>.el-submenu .el-submenu__title{font-size: 20px;}
</style>



// WEBPACK FOOTER //
// src/components/middles.vue